import lodash from 'lodash';
import apiService from '../apiService';

export default class TellersService {
    constructor() {
        this.tellers = [];
        this.loaded = false;
    }

    list() {
        if (this.loaded) {
            return Promise.resolve(this.tellers);
        }

        return apiService.getListTellers()
            .then(res => {
                this.loaded = true;
                this.tellers = lodash.get(res, 'data.data') || [];

                return this.tellers;
            });
    }
}
